import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

/**
 * Add cart with items
 */
export const newCartWithItems = createAsyncThunk(
  "Cart/newCartWithItems",
  async ({ data, documents }: any, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      //eslint-disable-next-line
      console.log("documents", documents);
      documents.map((document: any) => {
        formData.append("files", document);
      });

      if (data?.subscriptions) {
        formData.append("subscriptions", JSON.stringify(data?.subscriptions));
      }

      // ** user information
      formData.append("key", data.key);
      formData.append("country", data?.country);
      formData.append("adress", data?.adress);
      formData.append("userPhone", data?.userPhone);
      formData.append("zipCode", data?.zipCode);
      formData.append("state", data?.state);
      if (data?.tvaNumber) {
        formData.append("tvaNumber", data?.tvaNumber);
      }
      formData.append("userName", data?.userName);
      formData.append("userEmail", data?.userEmail);
      formData.append("codeClient", data?.codeClient);
      formData.append("currentLanguage", data?.language);

      // ** confirmation data
      formData.append("saveAddress", data?.saveAddress);
      formData.append("savePhoneNumber", data?.savePhoneNumber);

      const result = await axios.post("/add-cart-with-items", formData, {
        withCredentials: true,
      });

      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return result.data;
    } catch (error: any) {
      toast.error("Problème lors de l'ajout des articles au panier", {
        position: toast.POSITION.TOP_RIGHT,
      });

      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

/**
 * Get all carts with items for current user
 */
export const getAllCartwithItemsByUser = createAsyncThunk(
  "Cart/getAllCartwithItemsByUser",
  async (_, { rejectWithValue }) => {
    try {
      const result = await axios.get("/get-carts-user", {
        withCredentials: true,
      });

      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

/**
 * Update item of cart
 */
export const updateItemOfCart = createAsyncThunk(
  "Cart/updateItemOfCart",
  async (data: any, { rejectWithValue }) => {
    try {
      const result = await axios.put("/update-item-cart", data, {
        withCredentials: true,
      });

      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return result.data;
    } catch (error: any) {
      toast.error("Problème lors de la modification du panier", {
        position: toast.POSITION.TOP_RIGHT,
      });

      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

/**
 * Delete item of cart
 */
export const removeItemOfCart = createAsyncThunk(
  "Cart/removeItemOfCart",
  async (data: any, { rejectWithValue }) => {
    try {
      const result = await axios.delete("/delete-item-cart", {
        withCredentials: true,
        data,
      });

      if (result.data.success) {
        toast.success(result.data.description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return result.data;
    } catch (error: any) {
      toast.error("Problème lors de la suppression de l'article du panier", {
        position: toast.POSITION.TOP_RIGHT,
      });

      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

const CartSlice = createSlice({
  name: "CartSlice",
  initialState: {
    Cart: {},
    Carts: [],
    loading: false,
    errors: null,
    success: false,
  },

  reducers: {
    clearErrors: (state) => {
      state.errors = null;
    },

    clearCart: (state) => {
      state.Cart = {};
      state.Carts = [];
    },
  },

  extraReducers: (builder) => {
    builder

      // =========================
      // GET CARTS USER
      // =========================
      .addCase(getAllCartwithItemsByUser.pending, (state) => {
        state.loading = true;
        state.errors = null;
        state.success = false;
      })

      .addCase(getAllCartwithItemsByUser.fulfilled, (state, action) => {
        state.loading = false;
        state.Carts = action.payload?.data ?? action.payload?.Data ?? [];
        state.errors = null;
        state.success = true;
      })

      .addCase(
        getAllCartwithItemsByUser.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.Carts = [];
          state.errors = action.payload?.Description || action.payload;
          state.success = false;
        },
      )

      // =========================
      // ADD CART WITH ITEMS
      // =========================
      .addCase(newCartWithItems.pending, (state) => {
        state.loading = true;
        state.errors = null;
        state.success = false;
      })

      .addCase(newCartWithItems.fulfilled, (state, action) => {
        state.loading = false;
        state.Cart = action.payload.Data;
        state.errors = null;
        state.success = true;
      })

      .addCase(newCartWithItems.rejected, (state: any, action: any) => {
        state.loading = false;
        state.errors = action.payload?.Description || action.payload;
        state.success = false;
      })

      // =========================
      // UPDATE ITEM CART
      // =========================
      .addCase(updateItemOfCart.pending, (state) => {
        state.loading = true;
        state.errors = null;
        state.success = false;
      })

      .addCase(updateItemOfCart.fulfilled, (state, action) => {
        state.loading = false;
        state.Cart = action.payload.Data;
        state.errors = null;
        state.success = true;
      })

      .addCase(updateItemOfCart.rejected, (state: any, action: any) => {
        state.loading = false;
        state.errors = action.payload?.Description || action.payload;
        state.success = false;
      })

      // =========================
      // DELETE ITEM CART
      // =========================
      .addCase(removeItemOfCart.pending, (state) => {
        state.loading = true;
        state.errors = null;
        state.success = false;
      })

      .addCase(removeItemOfCart.fulfilled, (state, action) => {
        state.loading = false;
        state.Cart = action.payload.Data;
        state.errors = null;
        state.success = true;
      })

      .addCase(removeItemOfCart.rejected, (state: any, action: any) => {
        state.loading = false;
        state.errors = action.payload?.Description || action.payload;
        state.success = false;
      });
  },
});

export const { clearErrors, clearCart } = CartSlice.actions;

export default CartSlice.reducer;
